import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Modules/Components/Loading";
import { Navigate, useLocation } from "react-router-dom";
import { updatePath } from "../../Redux/Slices/ActivePathSlice";
import { Outlet } from 'react-router-dom'   

export const AdminValidator = () => {
    const [check, setCheck] = useState("pending");
    const location = useLocation();
    const user = useSelector((state)=>state.UserReducer.value);
    const dispatch = useDispatch();

    useEffect(() => {
        if (user.authenticated && user.role === 1) {
            setCheck("passed")
        }
        else {
            setCheck("failed")
        }
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(updatePath(location.pathname))
    }, [location])// eslint-disable-line react-hooks/exhaustive-deps

    if (check === "pending") {
        return <Loading/>
    }
    else if (check === "passed"){
        return <Outlet/>
    }
    else{
        return <Navigate to="/"/>
    }
};